import { render, staticRenderFns } from "./all.vue?vue&type=template&id=65dbf874&scoped=true&"
import script from "./all.vue?vue&type=script&lang=js&"
export * from "./all.vue?vue&type=script&lang=js&"
import style0 from "./all.vue?vue&type=style&index=0&id=65dbf874&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dbf874",
  null
  
)

export default component.exports